<template>
  <div>Invoice View</div>
</template>

<script>
export default {
  name: "Invoice",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>